import { Skeleton } from '@/core/ui';

export const CupsLoading = () => {
  return (
    <div className='h-screen w-full bg-content1 relative'>
      <div className='absolute top-0 left-4'>
        <Skeleton className='h-[294px] w-[52px] bg-danger/30' />
        <Skeleton className='h-[87px] w-[52px] bg-olive/30' />
      </div>
      <div className='flex h-full w-full justify-between'>
        <div className='flex flex-col pl-48'>
          <div className=' py-16'>
            <Skeleton className='h-[30px] w-52 bg-chalk/10' />

            <div className='w-full h-full flex space-x-12 mt-24'>
              <Skeleton className='w-[299px] h-[590px] bg-chalk/10' />
              <div className='flex flex-col space-y-6 max-w-[395px]'>
                <Skeleton className='w-[82px] h-[82px] bg-chalk/10' />
                <Skeleton className='h-[150px] w-80 bg-chalk/10' />

                <div className='flex items-center'>
                  <Skeleton className='h-[8.5px] w-[41px] bg-olive/30' />
                  <Skeleton className='h-[8.5px] w-[41px] bg-danger/30' />
                </div>
                <Skeleton className='h-[220px] w-[395px] bg-chalk/10' />
              </div>
            </div>
          </div>
          <div>
            <Skeleton className='bg-danger/30 rounded-full h-[72px] w-[296px]' />
          </div>
        </div>
        <div className='flex flex-col space-y-28 justify-end h-full'>
          <Skeleton className='h-[240px] w-[576px] bg-chalk/10' />

          <Skeleton className='w-[864px] h-[504px] bg-chalk/10' />
        </div>
      </div>
    </div>
  );
};
